module.exports = __webpack_public_path__ + "img/freeBg.565981bf.png";